import { useEffect, useState } from 'react';

const DEBOUNCE_DURATION = 300;

function debounce(func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = [func, wait, immediate];

    /* eslint-disable-next-line func-names */
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

export function useWindowDimensions() {
  const hasWindow = typeof window !== 'undefined';

  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;

    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  const handleResizeDebounced = debounce(handleResize, DEBOUNCE_DURATION);

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener('resize', handleResizeDebounced);

      return () => window.removeEventListener('resize', handleResizeDebounced);
    }

    return null;
  }, [hasWindow]);

  return windowDimensions;
}

export default useWindowDimensions;
